import shipmentSlice, { initialStateFilter, shipmentFilterSelector } from '@/redux/features/shipment.slice';
import { IResponse } from '@/types';
import { IShipmentSearch } from '@/types/shipment';
import { Badge, LegacyTabs } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { EShipmentType } from '../../config';

interface ShipmentTabProps {
  children: React.ReactNode;
  data: IResponse<IShipmentSearch> | undefined;
}

function ShipmentTab({ data, children }: ShipmentTabProps) {
  const dispatch = useDispatch();
  const TABS = [
    {
      id: EShipmentType.TRACKED_SHIPMENT,
      content: (
        <>
          Tracked shipments
          {data?.data && (
            <>
              &nbsp;&nbsp;<Badge tone="info">{`${data?.data.shipmentCount.trackedShipments}`}</Badge>
            </>
          )}
        </>
      ),
      panelID: EShipmentType.TRACKED_SHIPMENT,
    },
    {
      id: EShipmentType.UNTRACKED_SHIPMENT,
      content: (
        <>
          Untracked shipments
          {data?.data && (
            <>
              &nbsp;&nbsp;<Badge tone="info">{`${data?.data.shipmentCount.untrackedShipments}`}</Badge>
            </>
          )}
        </>
      ),
      panelID: EShipmentType.UNTRACKED_SHIPMENT,
    },
    {
      id: EShipmentType.UNFULFILLED_SHIPMENT,
      content: (
        <>
          Unfulfilled shipments
          {data?.data && (
            <>
              &nbsp;&nbsp;<Badge tone="info">{`${data?.data.shipmentCount.unfulfilledShipments}`}</Badge>
            </>
          )}
        </>
      ),
      panelID: EShipmentType.UNFULFILLED_SHIPMENT,
    },
  ];

  const shipmentFilter = useSelector(shipmentFilterSelector);
  const selected =
    shipmentFilter.type === EShipmentType.TRACKED_SHIPMENT
      ? 0
      : shipmentFilter.type === EShipmentType.UNTRACKED_SHIPMENT
      ? 1
      : 2;

  const handleTabChange = (selectedTabIndex: number) => {
    dispatch(shipmentSlice.actions.handleChangeTableFilter({ ...initialStateFilter, type: TABS[selectedTabIndex].id }));
  };

  return (
    <LegacyTabs tabs={TABS} selected={selected} onSelect={handleTabChange}>
      {children}
    </LegacyTabs>
  );
}

export default ShipmentTab;
